import { formatNumber } from './format-number';

export function calculatePrices(
    selectedPackage,
    addedTickets,
    selectedHotel,
    selectedHotelRoomType,
    selectedHotelNights,
    selectedHotelRange,
    dinner,
    selectedDinner,
    optionalHotel,
    withoutHotel,
) {
    const persons = getPricePerPerson(
        selectedPackage,
        addedTickets,
        selectedHotel,
        selectedHotelNights,
        selectedHotelRange,
        dinner,
        selectedDinner,
        optionalHotel,
        withoutHotel,
    );

    const singleRoomAddon = getSingleRoomAddonPrice(
        addedTickets,
        selectedHotel,
        selectedHotelRoomType,
        selectedHotelNights,
        selectedHotelRange,
    );

    return {
        quantity: addedTickets.length,
        multiple: addedTickets.length > 1,
        price: formatNumber(getTotalPrice(
            selectedPackage,
            addedTickets,
            selectedHotel,
            selectedHotelRoomType,
            selectedHotelNights,
            selectedHotelRange,
            dinner,
            selectedDinner,
            optionalHotel,
            withoutHotel,
        ), 0, ' ', ' '),
        ppt: persons.length > 0
            ? formatNumber(persons[0].price, 0, ' ', ' ')
            : 0,
        addons: {
            single: singleRoomAddon,
        },
        isGroup: persons.length > 1,
    };
}

export function getSingleRoomAddonPrice(
    addedTickets,
    hotel,
    roomType,
    nights,
    range,
) {
    if (
        hotel == null ||
        roomType !== 0 ||
        addedTickets.length % 2 === 0
    ) {
        return 0;
    }

    let price = hotel.ranges[nights][range].price_single;
    let includedPrice = hotel.ranges[nights][range].price;

    return price - includedPrice;
}

function getPricePerPerson(
    selectedPackage,
    addedTickets,
    selectedHotel,
    selectedHotelNights,
    selectedHotelRange,
    dinner,
    selectedDinner,
    optionalHotel,
    withoutHotel,
) {
    const packagePrices = getPricePerPackage(
        selectedPackage,
        addedTickets,
        selectedHotel,
        optionalHotel,
        withoutHotel,
    );

    const hotelPrice = getHotelPrice(
        selectedPackage,
        selectedHotel,
        selectedHotelNights,
        selectedHotelRange,
    );

    const dinnerPrice = getDinnerPrice(dinner, selectedDinner);

    let persons = [];
    for (let i = 0; i < packagePrices.length; i++) {
        const price = packagePrices[i].price + hotelPrice + dinnerPrice;
        persons.push({
            amount: packagePrices[i].amount,
            price: price,
            type: packagePrices[i].type,
        });
    }

    return persons;
}

function getPricePerPackage(
    selectedPackage,
    addedTickets,
    selectedHotel,
    optionalHotel,
    withoutHotel,
) {
    let group = [];
    let prices = [];

    for (let i = 0, l = addedTickets.length; i < l; i++) {
        let ticket = addedTickets[i];
        group[ticket.id] = group[ticket.id] || [];
        group[ticket.id].push(ticket);
    }

    const needsHotel = !optionalHotel && !withoutHotel;

    for (let id in group) {
        let ticket = group[id][0];
        let type = ticket.type ? ticket.type : null;
        let hotelPrice = 0;

        if (needsHotel || selectedHotel != null) {
            hotelPrice = selectedPackage.hotel.price;
        }

        prices.push({
            name: ticket.name,
            price: parseInt(ticket.price) + parseInt(hotelPrice),
            amount: group[id].length,
            type: type,
        });
    }

    return prices;
}

function getHotelPrice(
    selectedPackage,
    selectedHotel,
    selectedHotelNights,
    selectedHotelRange,
) {
    if (selectedHotel == null) {
        return null;
    }

    const price = selectedHotel.ranges[selectedHotelNights][selectedHotelRange].price;
    const included_price = selectedPackage.hotel.price;

    return price - included_price;
}

function getDinnerPrice(dinner, selectedDinner) {
    if (selectedDinner == null || dinner == null) {
        return null;
    }

    return dinner.price;
}

export function getTotalPrice(
    selectedPackage,
    addedTickets,
    selectedHotel,
    selectedHotelRoomType,
    selectedHotelNights,
    selectedHotelRange,
    dinner,
    selectedDinner,
    optionalHotel,
    withoutHotel,
) {
    const packagePrice = getPricePerPerson(
        selectedPackage,
        addedTickets,
        selectedHotel,
        selectedHotelNights,
        selectedHotelRange,
        dinner,
        selectedDinner,
        optionalHotel,
        withoutHotel,
    );

    const singleRoomAddon = getSingleRoomAddonPrice(
        addedTickets,
        selectedHotel,
        selectedHotelRoomType,
        selectedHotelNights,
        selectedHotelRange,
    );

    const tripleRoomAddon = getPriceAddonTrippelRoom(
        addedTickets,
        selectedHotel,
        selectedHotelRoomType,
        selectedHotelNights,
        selectedHotelRange,
    );

    let packagePriceTotal = 0;
    for (let i = 0; i < packagePrice.length; i++) {
        packagePriceTotal =
            packagePriceTotal +
            packagePrice[i].price *
            packagePrice[i].amount;
    }

    return packagePriceTotal + tripleRoomAddon + singleRoomAddon;
}

function getPriceAddonTrippelRoom(
    addedTickets,
    selectedHotel,
    selectedHotelRoomType,
    selectedHotelNights,
    selectedHotelRange,
) {
    if (
        selectedHotel == null ||
        selectedHotelRoomType !== 1 ||
        addedTickets.length % 2 === 0
    ) {
        return null;
    }

    const price = selectedHotel.ranges[selectedHotelNights][selectedHotelRange].price_tripple;
    const included_price = selectedHotel.ranges[selectedHotelNights][selectedHotelRange].price;
    return (price - included_price) * 3;
}
